import React, { useEffect, useState } from 'react';
import { ColumnProps } from 'antd/lib/table';
import { Button, FilterWidget, FormRangePicker, MasterDetailForm, Table, Widget } from '@digital/ui';
import { Tooltip } from 'antd';
import {
  Demanda,
  getDemandasDemandanteConcluido,
  getDemandasPreSuprimentosConcluido,
  TipoDemanda,
} from '@app/api/demanda';
import { currencyFormat } from '@app/helpers/numbers';
import { dateFormat } from '@app/helpers/dateTimeFormats';

const DemandasConcluido = () => {
  const [dados, setDados] = useState<Demanda[]>([]);
  const [update, setUpdate] = useState(false);
  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);

  const onUpdate = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    getDemandasDemandanteConcluido({ periodoInicio, periodoFim }).then(data => {
      if (data) {
        setDados(data);
      }
    });
  }, [update]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Código',
      dataIndex: 'identificadorTexto',
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      render: (text, record) => (record.tipo ? TipoDemanda[record.tipo] : ''),
    },
    {
      title: 'Tipo de Serviço',
      dataIndex: 'tipoServico',
    },
    {
      title: 'Valor Final',
      dataIndex: 'expectativaValorFinal',
      render: (text, record) => currencyFormat(record.expectativaValorFinal),
    },
    {
      title: 'RC',
      dataIndex: 'rc',
    },
    {
      title: 'OC',
      dataIndex: 'oc',
    },
    {
      title: 'Status',
      dataIndex: 'statusDemandaNome',
    },
    {
      title: 'Responsável Gpc',
      dataIndex: 'responsavelGpcNome',
    },
    {
      title: 'Comprador',
      dataIndex: 'compradorNome',
    },
    {
      title: 'Gov. Aprovação',
      dataIndex: 'govAprovacao',
    },
    {
      title: 'DDI',
      dataIndex: 'ddi',
    },
    {
      title: 'Ações',
      render: (index, record) => (
        <Tooltip title="Ir para Demanda">
          <Button
            type="link"
            icon="arrows-circled_up_right_2"
            name="irparaBm"
            onClick={() => {
              let urlBase = window.location.origin;
              window.open(urlBase + `/demanda/questionario/${record.id}`);
            }}
            href="#"
          />
        </Tooltip>
      ),
      width: '1%',
    },
  ];

  return (
    <>
      <FilterWidget
        title="Filtro"
        key="filterWidget"
        actions={[
          <Button type="primary" key="filterBtn" onClick={() => onUpdate()}>
            Pesquisar
          </Button>,
        ]}>
        <MasterDetailForm>
          <FormRangePicker
            value={[periodoInicio, periodoFim]}
            startName="dataInicio"
            endName="dataFinal"
            format={dateFormat}
            label="Período"
            span={4}
            onChange={dates => {
              setPeriodoInicio(dates[0]);
              setPeriodoFim(dates[1]);
            }}
          />
        </MasterDetailForm>
      </FilterWidget>
      <Widget title="Concluídos / Cancelados">
        <Table columns={columns} dataSource={dados} />
      </Widget>
    </>
  );
};
export default DemandasConcluido;
